import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Container,
    Grid, Input, InputAdornment, MenuItem, Modal, Select,
    Stack, TextareaAutosize, TextField,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import DocumentIcon from "../assets/buttons/document/document-white-black.png"
import SaveIcon from "../assets/buttons/save/save-white-yellow.png"
import SaveIcon2 from "../assets/buttons/save/save-white-black.png"
import ImageButton from "./ImageButton";
import Swal from "sweetalert2";
import {useOutletContext} from "react-router-dom";
import VehicleItemSection from "./VehicleItemSection";
import VehicleItem from "./VehicleItem";
import ReactCountryFlag from "react-country-flag";
import VehicleDocumentTypesService from "../services/VehicleDocumentTypesService";
import VehicleDocumentRow from "./VehicleDocumentRow";


// function ExpandMoreIcon() {
//     return null;
// }

export default function VehicleItemSectionDocuments({
                                                        vehicleData,
                                                        selected = true,
                                                        reloadHandler,
                                                        vehicleDocumentTypes
                                                    }) {
    const [apiUri] = useOutletContext();
    const token = localStorage.getItem('accessToken');
    const {t} = useTranslation('common');
    const formRef = React.useRef();

    const maxFileSize = 5;  // Mb

    const [popupOpen, setPopupOpen] = React.useState(false);
    const addDocumentClickedHandler = () => setPopupOpen(true);
    const closeAddDocumentHandler = () => setPopupOpen(false);

    function submitHandler(event) {
        event.preventDefault();
        if (!formRef.current.reportValidity()) {
            return;
        }

        let data = new FormData();

        let documentTypeId = formRef.current.elements['document_type'].value;
        let documentType = getVehicleDocumentTypeById(documentTypeId);


        data.append('vehicle_id', vehicleData.vehicleId);
        data.append('vehicle_document_type_id', documentTypeId);
        data.append('label', t(documentType.label));
        data.append('file', formRef.current.elements['file'].files[0]);

        // console.log(data);

        fetch(apiUri + 'vehicle_document_insert', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: data
        })
            .then(data => data.json())
            .then(data => {
                if (data.state === 'OK') {
                    Swal.fire({
                        text: t('vehicle.item.documents.add.success'),
                        icon: 'success',
                        timer: 2000,
                        customClass: {
                            container: 'my-swal'
                        }
                    })
                        .then(() => {
                            // TODO Pas ouf de recharger tous les vehicules, mais ca fonctionne
                            reloadHandler();
                            closeAddDocumentHandler();
                        });
                } else {
                    Swal.fire({
                        text: t(data.message),
                        icon: 'error',
                        customClass: {
                            container: 'my-swal'
                        }
                    });
                }
            })
    }

    function getVehicleDocumentTypeById(id) {
        return vehicleDocumentTypes.find(documentType => documentType.id == id);
    }

    function fileChangedHandler(e) {
        // let fileInput = e.target;
        let fileInput = document.getElementById("file");
        // console.log(fileInput.files[0].size);
        // console.log(fileInput.value);

        var ext = fileInput.value.match(/\.([^\.]+)$/)[1];
        switch (ext) {
            case 'jpg':
            case 'bmp':
            case 'png':
            case 'tif':
            case 'pdf':
                break;
            default:
                Swal.fire({
                    text: t('vehicle.item.documents.add.error_format'),
                    icon: 'error',
                    customClass: {
                        container: 'my-swal'
                    }
                });
                fileInput.value = '';
                return;
        }
        if (fileInput.files[0].size > maxFileSize * 1024 * 1024) {
            Swal.fire({
                text: t('vehicle.item.documents.add.error_size'),
                icon: 'error',
                customClass: {
                    container: 'my-swal'
                }
            });
            fileInput.value = '';
            return
        }
    }

    return (
        <VehicleItemSection
            icon={DocumentIcon}
            label={t('vehicle.item.documents.label')}
            detailContent={<>
                <Stack>
                    {
                        vehicleData.documents.length == 0 &&
                        <Typography sx={{fontStyle: 'italic'}}>{t('vehicle.item.documents.no_document')}</Typography>
                    }
                    {
                        vehicleData.documents.map((document, i) => {
                            return (<VehicleDocumentRow
                                vehicleData={vehicleData} key={i} document={document} reloadHandler={reloadHandler}
                            />)
                        })}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="yellow"
                        sx={{mt: '15px', mb: '20px'}}
                        onClick={addDocumentClickedHandler}
                    >
                        {t('vehicle.item.documents.add.label')}
                    </Button>

                    <Modal
                        open={popupOpen}
                        onClose={closeAddDocumentHandler}
                    >
                        <Box sx={style}>
                            <Grid container>
                                <Grid item xs={0}>
                                    <img src={DocumentIcon} style={{width: '50px'}}></img>
                                </Grid>
                                <Grid item xs={10} container alignContent="center">
                                    <Typography fontSize="18px"
                                                marginLeft="10px"><b>{t('vehicle.item.documents.add.label')}</b></Typography>
                                </Grid>
                            </Grid>
                            <form onSubmit={submitHandler} ref={formRef}>
                                <Stack>
                                    <Select
                                        id="document_type"
                                        name="document_type"
                                        // label={t('vehicle.item.documents.add.document_type_label')}
                                        defaultValue={1}
                                        required
                                        onChange={
                                            e => {
                                                //setCountry(e.target.value);
                                            }
                                        }
                                    >
                                        <MenuItem>{window['test']}</MenuItem>
                                        {vehicleDocumentTypes != null &&

                                        vehicleDocumentTypes.map((documentType, i) => {
                                            return (
                                                <MenuItem key={i}
                                                          value={documentType.id}>{t(documentType.label)}</MenuItem>)
                                        })
                                        }
                                    </Select>
                                    <Input
                                        sx={{
                                            height: '50px'
                                        }}
                                        inputProps={{accept: 'image/*,application/pdf'}}
                                        required
                                        id="file"
                                        type="file"
                                        onChange={fileChangedHandler}
                                    />
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="yellow"
                                        sx={{mt: '15px', mb: '20px'}}
                                    >
                                        {t('vehicle.item.documents.add.save')}
                                    </Button>
                                </Stack>
                            </form>
                        </Box>
                    </Modal>
                </Stack>
            </>}
        />
    )
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};